var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assertNever from 'assert-never';
import {
    Guid,
    isIPrimitive
} from '@ef-carbon/primitive';
import evaluate from '../../evaluate';
import isIDirect from '../isIDirect';
import isIRandom from '../isIRandom';
import isIRemote from '../isIRemote';
import direct from './direct';
import random from './random';
import remote from './remote';
async function recurse({id, redirect, context, options}) {
    if (typeof id === 'string' || isIPrimitive(id)) {
        return {
            id: new Guid(id),
            redirect,
            context
        };
    } else if (isIDirect(id)) {
        const _a = await direct(id, context, options), {
                id: guid,
                redirect: override
            } = _a, rest = __rest(_a, [
                'id',
                'redirect'
            ]);
        return Object.assign({
            id: new Guid(guid),
            redirect: redirect || override
        }, rest);
    } else if (isIRandom(id)) {
        const _b = await random(id, context, options), {
                id: guid,
                redirect: override
            } = _b, rest = __rest(_b, [
                'id',
                'redirect'
            ]);
        return Object.assign({
            id: new Guid(guid),
            redirect: redirect || override
        }, rest);
    } else if (isIRemote(id)) {
        const _c = await remote(id, context, options), {
                id: guid,
                redirect: override
            } = _c, rest = __rest(_c, [
                'id',
                'redirect'
            ]);
        return Object.assign({
            id: new Guid(guid),
            redirect: redirect || override
        }, rest);
    } else {
        return assertNever(id);
    }
}
export async function linkProcessConditional(link, context, options) {
    const {
        redirect: redirection,
        conditions,
        fallback
    } = link;
    const redirect = redirection ? new Guid(redirection) : undefined;
    for (const [condition, id] of Object.entries(conditions)) {
        let result;
        try {
            ({result} = evaluate(condition, context));
        } catch (error) {
            if (error instanceof TypeError || error instanceof RangeError) {
                continue;
            } else {
                throw error;
            }
        }
        if (result) {
            return recurse({
                id,
                redirect,
                context,
                options
            });
        }
    }
    return recurse({
        id: fallback,
        redirect,
        context,
        options
    });
}
export {
    linkProcessConditional as process,
    linkProcessConditional as conditional
};
export default linkProcessConditional;    //# sourceMappingURL=conditional.js.map
